///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { notificationTypes } from "../helpers/types";
import messages from "./messages";
import RxoLogo from "../images/RxoLogo.png";

const baseURL = window.REACT_APP_RFQ_WEB_CLIENT_URL;

const createBrowserNotification = newNotification => {
  const { bidName, plainTextContent, notificationType } = newNotification;
  var options = {
    body: plainTextContent,
    icon: RxoLogo
  };
  var title =
    notificationType === notificationTypes.systemMessage
      ? messages.systemUpdates.defaultMessage
      : bidName;
  var notification = new Notification(title, options);
  notification.onclick = () => window.open(`${baseURL}notifications`);
};

export default createBrowserNotification;
